import { observable } from 'mobx';
import {PaginationMeta} from '../../../types';
import {OrderSchema} from '../../../types/schema';

export class AccountOrdersPageModel {
  @observable
  loadingMore: boolean = false;

  @observable
  orders: Array<OrderSchema>;

  @observable
  pagination: PaginationMeta;
}